module.exports = __webpack_public_path__ + "img/Tablet - 22.bb3517d4.png";